import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.js'
import { CustomerQuote } from './customer/CustomerQuote.js'
import './styles/theme.css'

/**
 * /q/<token> is the PUBLIC customer quote page (phase 3) — it mounts on its
 * own, instead of the portal app: no sign-in, no portal context, no session
 * round-trips. Everything else is the staff/partner portal.
 * (Decision 47: the public page must never vary on a portal session cookie —
 * not mounting the portal at all is the strongest form of that guarantee.)
 */
const qMatch = /^\/q\/([^/]+)\/?$/.exec(window.location.pathname)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {qMatch ? <CustomerQuote token={decodeURIComponent(qMatch[1])} /> : <App />}
  </StrictMode>,
)
